import React, {Component} from 'react';
import SpecializationContent from '../function-components/SpecializationContent'

function Specialization() {
    return (
        <>
            <SpecializationContent />
        </>
    );
   }

export default Specialization;